module.exports = __webpack_public_path__ + "static/img/huodong.46dfdf28.png";